import Cookies from "js-cookie";
import PopupMailer from "@components/PopupMailer";
import styles from "./styles/newsletter.module.css";

export function Newsletter({ modal, subscribed, popupMailers }) {
  // If no popup mailers are configured, fall back to old modal system
  if (!popupMailers || popupMailers.length === 0) {

    if (modal === false) {
      return null;
    }

    if (Cookies.get("klaviyo_modal_subscribed") || Cookies.get("modal_closed")) {
      return null;
    }

    if (subscribed) {
      return null;
    }
    const counter = Cookies.get("klaviyo_modal_viewed_counter");

    if (counter && parseInt(counter) >= 3) {
      return null;
    }

    return null;

  }
  // Use the new popup mailer system
  return (
    <div className={styles.container}>
      <PopupMailer popupMailers={popupMailers} />
    </div>
  );
}
